import styled from "styled-components";

export const BodyContainer = styled.div<{ w: string; h?: string }>`
  width: ${props => props.w ? props.w : "90%"};
  overflow: hidden;
  flex-grow: 1;
  background-color: #F5F5F5;
  height: ${props => props.h ? props.h : props.theme.height};
`;
